export default {
  real_estate: {
    title: 'ADVERTISE A REAL ESTATE LISTING',
    data: [
      {
        title: 'Single Real Estate Listing',
        description: 'Advertise one listing to generate buyer and seller leads across Facebook and Instagram.',
        image: 'single-real-estate-listing.png',
        link: process.env.VUE_APP_EVOCALIZE_SINGLE_LISTING,
        requireListingsPermission: true,
      },
      {
        title: 'Multiple Real Estate Listings',
        description: 'Advertise several listings in one carousel ad to generate buyer and seller leads across Facebook and Instagram.',
        image: 'multiple-real-estate-listings.png',
        link: process.env.VUE_APP_EVOCALIZE_MULTI_LISTING,
        requireListingsPermission: true,
      },
    ]
  },
  own_ad: {
    title: 'CREATE MY OWN AD',
    data: [
      {
        title: 'Use your own video in a Facebook and Instagram ad to generate traffic or leads',
        image: 'use-your-own-video.png',
        linkTraffic: process.env.VUE_APP_EVOCALIZE_OWN_VIDEO_GENERATE_TRAFFIC,
        linkLeads: process.env.VUE_APP_EVOCALIZE_OWN_VIDEO_GENERATE_LEADS,
        requireListingsPermission: false,
      },
      {
        title: 'Use your own image in a Facebook and Instagram ad to generate traffic or leads',
        image: 'use-your-own-image.png',
        linkTraffic: process.env.VUE_APP_EVOCALIZE_OWN_IMAGE_GENERATE_TRAFFIC,
        linkLeads: process.env.VUE_APP_EVOCALIZE_OWN_IMAGE_GENERATE_LEADS,
        requireListingsPermission: false,
      }
    ],
  },
};
